import { Box } from "@mui/material";
import { globalStyles } from "styles";
import intersect from "../../../assets/img/Intersect.svg";
import ellipse from "../../../assets/img/Ellipse-83.png";
import polygon from "../../../assets/img/Polygon-1.svg";

const AboutUsImage = ({ index, image_url }) => {
  const classes = globalStyles();
  return (
    <Box
      position="relative"
      display="flex"
      justifyContent={index % 2 !== 0 ? "right" : "left"}
      mt={index % 2 !== 0 && 4}
      key={index}
    >
      <Box position="relative" zIndex={1}>
        <Box
          display="flex"
          justifyContent="center"
          bgcolor="white"
          p={1}
          width={366}
          height={266}
        >
          <img
            alt="banner"
            src={image_url}
            className={classes?.aboutUsImageContent}
          />
        </Box>
      </Box>
      {index === 0 && (
        <>
          <Box position="absolute" top={75} left={350} zIndex={0}>
            <img src={intersect} alt="intersect" />
          </Box>
          <img
            src={ellipse}
            alt="ellipse"
            className={classes?.aboutImageIntersectEllipse}
          />
        </>
      )}

      {index === 1 && (
        <Box position="absolute" bottom={50} right={340} zIndex={0}>
          <img src={polygon} alt="polygon" />
          <img
            src={ellipse}
            alt="ellipse"
            className={classes?.aboutImageOuterEllipse}
          />
        </Box>
      )}
    </Box>
  );
};

export default AboutUsImage;
